export default {
  addOns: 'Ti\u1ec7n \u00edch b\u1ed5 sung',
  availability: 'T\u00ecnh tr\u1ea1ng',
  availabilityDaySelector: 'Ch\u1ecdn ng\u00e0y c\u00f3 s\u1eb5n',
  unavailable: 'Kh\u00f4ng c\u00f3 s\u1eb5n',
  person: 'ng\u01b0\u1eddi',
  people: 'ng\u01b0\u1eddi',
  reserveNow: '\u0110\u1eb7t ngay',
  selectTime: 'Ch\u1ecdn gi\u1edd',
  select: 'Ch\u1ecdn',
  reserve: '\u0110\u1eb7t ch\u1ed7',
  time: 'Th\u1eddi gian',
  tier: 'H\u1ea1ng',
  questions: 'C\u00e2u h\u1ecfi',
  addToCart: 'Th\u00eam v\u00e0o gi\u1ecf h\u00e0ng',
  checkout: 'Thanh to\u00e1n',
  total: 'T\u1ed5ng c\u1ed9ng',
  whatsIncluded: 'Bao g\u1ed3m nh\u1eefng g\u00ec',
  showMore: 'Xem th\u00eam',
  showLess: 'Thu g\u1ecdn',
  session: 'Phi\u00ean',
  viewDetails: 'Xem chi ti\u1ebft',
  findAvailability: 'T\u00ecm t\u00ecnh tr\u1ea1ng',
  loading: '\u0110ang t\u1ea3i',
  capacity: 'S\u1ee9c ch\u1ee9a',
  noAvailableSessionsOnThisDate:
    'Kh\u00f4ng c\u00f3 phi\u00ean tr\u1ed1ng v\u00e0o ng\u00e0y n\u00e0y',
  noGroupAvailableOnThisDateAndTime:
    'Kh\u00f4ng c\u00f3 {{groupTitle}} v\u00e0o ng\u00e0y v\u00e0 gi\u1edd n\u00e0y',
  noCollectionFound: 'Kh\u00f4ng t\u00ecm th\u1ea5y b\u1ed9 s\u01b0u t\u1eadp!',
  noResourceGroupFound:
    'Kh\u00f4ng t\u00ecm th\u1ea5y nh\u00f3m t\u00e0i nguy\u00ean!',
  noData: 'Kh\u00f4ng c\u00f3 d\u1eef li\u1ec7u!',
  continue: 'Ti\u1ebfp t\u1ee5c',
  night: '\u0111\u00eam',
  nights: '\u0111\u00eam',
  noAvailableSessionsForSelectedDates:
    'M\u1ed9t s\u1ed1 ng\u00e0y trong l\u1ef1a ch\u1ecdn c\u1ee7a b\u1ea1n kh\u00f4ng c\u00f3 phi\u00ean tr\u1ed1ng. Vui l\u00f2ng ch\u1ecdn ng\u00e0y kh\u00e1c.',
  from: 't\u1eeb',
  dateRangeSelector: 'Ch\u1ecdn kho\u1ea3ng ng\u00e0y',
  priceTierRadioGroup: 'Ch\u1ecdn m\u1ee9c gi\u00e1',
  startTime: 'Giờ bắt đầu',
  duration: 'Thời lượng',
  lengthOfStay: 'Thời gian lưu trú',
  startDate: 'Ngày bắt đầu',
  endDate: 'Ngày kết thúc',
  selectDates: 'Chọn ngày',
  more: 'Thêm',
  selectStartTime: 'Chọn giờ bắt đầu',
  endTime: 'Giờ kết thúc',
  selectEndTime: 'Chọn giờ kết thúc',
  morning: 'Buổi sáng',
  afternoon: 'Buổi chiều',
  save: 'Lưu',
  selectDuration: 'Chọn thời lượng',
  forLength: 'cho {{length}}',
  moreDates: 'thêm {{count}}',
  addDate: 'Thêm ngày',
  start: 'Bắt đầu',
  end: 'Kết thúc',
  pickupFrom: 'Nhận từ',
  returnBy: 'Trả trước',
  day: 'ngày',
  days: 'ngày',
  hour: 'giờ',
  hours: 'giờ',
};
